import { useEffect, useState } from "react";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import {
  HasInitValueBox,
  ModalRowContentContainer,
} from "../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import { macroStateOptionList } from "../MacroStateChangeModal/macrostate";
import UserMacroStateUpdateModal from "../UserMacroStateUpdateModal/UserMacroStateUpdateModal";
import AlertModal from "../../../../Modal/AlertModal";
import { toast } from "react-toastify";
import { useApi } from "../../../../../hooks/useApi";
import { useParams } from "react-router-dom";
import Loader from "../../../../DefaultStyles/Loader";

interface Props extends DefaultModalCommonProps {
  userData: {
    uid: number;
    nickname: string;
    name: string;
  };
  macro: number;
  isExitMember?: boolean;
}

export default function MacroStateModal({
  closeEvent,
  userData,
  macro,
  isExitMember,
  confirmEvent,
}: Props) {
  const { partyId } = useParams();

  const [stateUpdateModal, setStateUpdateModal] = useState(false);
  const [normalizeModal, setNormalizeModal] = useState(false);
  const [fetch, setFetch] = useState(false);

  const { response, loading, error } = useApi({
    method: "post",
    url: fetch ? "party/macro/inviteNetflix" : undefined,
    data: {
      partyid: partyId ? +partyId ?? 0 : 0,
      uid: userData.uid ? userData.uid ?? 0 : 0,
    },
  });

  useEffect(() => {
    if (response?.status === 200 || response?.status === 201) {
      setNormalizeModal(false);
      closeEvent();
      toast.success(
        `${userData.uid}_${userData.name}_${userData.nickname} 님을 다시 초대할게요`
      );
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "재초대에 실패했습니다");
    }
  }, [error]);

  return (
    <>
      <DefaultModalLayout
        modalTitle="매크로 상태"
        closeEvent={closeEvent}
        confirmEvent={() => closeEvent()}
        cancelBtn={<></>}
        confirmBtnText="닫기"
        isSmallModal
      >
        <ModalRow>
          <ModalLabel style={{ width: 80 }}>대상</ModalLabel>

          <ModalRowContentContainer style={{ width: "calc(100% - 80px)" }}>
            <HasInitValueBox>
              {userData.uid}_{userData.name}_{userData.nickname}
            </HasInitValueBox>
          </ModalRowContentContainer>
        </ModalRow>

        <ModalRow>
          <ModalLabel style={{ width: 80 }}>상태</ModalLabel>

          <ModalRowContentContainer style={{ width: "calc(100% - 80px)" }}>
            <HasInitValueBox style={{ width: "auto" }}>
              {
                macroStateOptionList(true).find((m) => m.value === macro + "")
                  ?.label
              }
            </HasInitValueBox>

            <ConfirmBtn
              btnText="변경"
              btnColor="mint"
              btnClickEvent={() => setStateUpdateModal(true)}
              isDisabled={isExitMember}
            />

            <ConfirmBtn
              btnText="정상화 확인"
              btnColor="mint"
              isDisabled={
                isExitMember ||
                !(
                  macro === 2 ||
                  macro === 3 ||
                  macro === 4 ||
                  macro === 5 ||
                  macro === 6 ||
                  macro === 16 ||
                  macro === 17
                )
              }
              btnClickEvent={() => setNormalizeModal(true)}
            />
          </ModalRowContentContainer>
        </ModalRow>
      </DefaultModalLayout>

      {/* 매크로 상태 변경 모달 */}
      {stateUpdateModal && (
        <UserMacroStateUpdateModal
          userData={{
            uid: userData.uid,
            name: userData.name,
            nickname: userData.nickname,
          }}
          closeEvent={() => setStateUpdateModal(false)}
          confirmEvent={() => {
            if (confirmEvent) confirmEvent();
            closeEvent();
          }}
        />
      )}

      {/* 매크로 정상화 확인 모달 */}
      {normalizeModal && (
        <AlertModal
          title={"계정 정상화를 확인하고\n다시 초대를 진행할까요?"}
          confirmText="예"
          customCancelBtn={
            <ConfirmBtn
              btnText="아니요"
              btnColor="white"
              btnClickEvent={() => setNormalizeModal(false)}
            />
          }
          confirmEvent={() => setFetch(true)}
        />
      )}

      {loading && <Loader />}
    </>
  );
}
